export function clampPercent(n: number, min: number, max: number): number {
  if (!Number.isFinite(n)) return min
  return Math.min(max, Math.max(min, n))
}

/** Display string in the input (includes %). */
export function formatPercentDisplay(zoomPercent: number, min: number, max: number): string {
  return `${Math.round(clampPercent(zoomPercent, min, max))}%`
}

export function parsePercentInput(raw: string): number | null {
  const t = raw.replace(/%/g, '').trim()

  if (t === '') return null
  const n = Number.parseFloat(t)

  return Number.isFinite(n) ? n : null
}

export function isAcceptableZoomPercent(raw: string, min: number, max: number): boolean {
  const n = parsePercentInput(raw)

  return n != null && n >= min && n <= max
}
